

export interface IFormulationState {
    // getAllFormulationDetails:any;
    getAllFormulationStockSuccess: any;
    getAllFormulationStockError: any;
    getAllFormulationsSuccess: any;
    getAllFormulationsError: any;
    getAllFormulationsByCompanyIdSuccess: any;
    getAllFormulationsByCompanyIdError: any;
    getAddFormulationSuccess: any;
    getAddFormulationError: any;
    getEditFormulationSuccess: any;
    getEditFormulationError: any;

    getFormulationNumberSuccess: any;
    getFormulationNumberError: any;
    getInActiveStatusSuccess: any;
    getInActiveStatusError: any;
    getActiveStatusSuccess: any;
    getActiveStatusError: any;
    getFormulationError: any;
    getFormulaByIdSucces: any;
    getFormulaByIdError: any;
    getActiveFormulationSuccess: any;
    getActiveFormulationError: any;
    getMlcsbyFormulaIdSuccess: any;
    getMlcsbyFormulaIdError: any;
    getImportProductSuccess: any;
    getImportProductError: any;
    getParentFormulasSuccess: any;
    getParentFormulasError: any;
    getSubEditFormulaSuccess: any;
    getSubEditFormulaError: any;
}

export const initialFormulationState: IFormulationState =  {
    // getAllFormulationDetails:null,
    getAllFormulationStockSuccess : null,
    getAllFormulationStockError : null,
    getAllFormulationsSuccess : null,
    getAllFormulationsError : null,
    getAllFormulationsByCompanyIdSuccess : null,
    getAllFormulationsByCompanyIdError : null,
    getAddFormulationSuccess : null,
    getAddFormulationError : null,
    getEditFormulationSuccess : null,
    getEditFormulationError : null,

    getFormulationNumberSuccess: null,
    getFormulationNumberError: null,
    getInActiveStatusSuccess: null,
    getInActiveStatusError: null,
    getActiveStatusSuccess: null,
    getActiveStatusError: null,
    getFormulationError: null,
    getFormulaByIdSucces : null,
    getFormulaByIdError : null,
    getActiveFormulationSuccess : null,
    getActiveFormulationError : null,
    getMlcsbyFormulaIdSuccess : null,
    getMlcsbyFormulaIdError: null,
    getImportProductSuccess : null,
    getImportProductError: null,
    getParentFormulasSuccess : null,
    getParentFormulasError: null,
    getSubEditFormulaSuccess : null,
    getSubEditFormulaError: null,
};
